export const ActionTypes = {
  LOADING: "BULK_UPDATE_OPTION_CRITERIA_LOADING",
  ERROR: "BULK_UPDATE_OPTION_CRITERIA_ERROR",
  SUCCESS: "BULK_UPDATE_OPTION_CRITERIA_SUCCESS",
  SET_LOADING: "SET_LOADING",
};
